'use strict';

class AttachmentList {
  constructor(invoiceService, creditNoteService, offerService, orderConfirmationService) {
    this.invoiceService = invoiceService;
    this.creditNoteService = creditNoteService;
    this.offerService = offerService;
    this.orderConfirmationService = orderConfirmationService;
  }

  $onInit() {
    this.files = [];
  }
}

AttachmentList.$inject = ['invoiceService', 'creditNoteService', 'offerService', 'orderConfirmationService'];


const attachmentList = {
  bindings: {
    files: '<'
  },
  controller: AttachmentList,
  template: `
    <div ng-show="$ctrl.files.length">
      <b>Vedlegg:</b>
      <ul style="list-style: none; margin-top: 10px;">
        <li ng-repeat="file in $ctrl.files track by file.number">
          <a href="{{ file.uri }}" target="_blank">
            <i class="fa fa-file-o"></i>
            {{ file.filename }}
          </a>
        </li>
      </ul>
    </div>
  `
};

angular
  .module('SendRegning')
  .component('attachmentList', attachmentList);
